<template>
  <div class="out-page">
    <div v-wechat-title='"最無厘頭放置手遊《最強蝸牛》"'></div>
    <div class="five-pc-page">
      <div class="small-title"></div>
      <div class="big-title"></div>
      <div class="fb-btn" @click="goFb"></div>
      <div class="video-btn" :class="{ playing: isPlaying }" @click="toggleMusic">
      </div>
      <audio ref="bgMusic" loop>
        <source src="../../snail_5thLeading/index/snail.mp3" type="audio/mpeg" />
      </audio>

    </div>

    <div class="content-footer">
      <div class="footer-content zh_HK">
        <div class="footer-box">
          <div class="left-content">
            <a target="_blank" href="https://law.snell.com.tw/zh-tw/service_agreement.html">服務條款</a>
            <span class="line"></span>
            <a target="_blank" href="https://law.snell.com.tw/zh-tw/privacy_policy.html">隱私協議</a>
          </div>
          <div class="l-logo" style="margin-right: 10px">
            <img src='https://download4.qcplay.com/qcgame-api/gPoRObLEHj6gH4Nttorxvu9j4z5bXnJ13ASABCat.png'>
          </div>

          <div class="right-content">
            <div class="r-text">
              <p>*思耐爾數位為最強蝸牛在台港澳的授權代理商。</p>
              <p>*本遊戲因涉及暴力、不當言語之情節，依遊戲軟體分級管理辦法分類為輔12級。</p>
              <p>*注意使用時間，避免沉迷於遊戲。</p>
              <p>*本遊戲為免費遊戲，但遊戲內另提供購買虛擬遊戲幣、物品等付費服務，請依個人興趣及能力適度消費。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>

import { getTimeStamp, buriedLogger, analysisParams } from '@/utils/utils';
export default {
  components: {},
  data() {
    return {
      isPlaying: true
    };
  },
  created() {
  },
  beforeDestroy() {
    document.documentElement.classList.remove('leading-page-active');
    document.body.classList.remove('leading-page-active');
  },
  mounted() {
    this.$nextTick(() => {
      this.monitoringEquipment();
      this.playMusic();
      // 埋点
      document.documentElement.classList.add('leading-page-active');
      document.body.classList.add('leading-page-active');
      const bl = buriedLogger("snail", "蜗牛_港澳台五周年_前导页h5");
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum("蜗牛_港澳台五周年_前导页统计");
      }, 200);
    });
  },
  computed: {},
  methods: {
    playMusic() {
      const music = this.$refs.bgMusic;
      // 尝试播放音频
      music.play().then(() => {
        this.isPlaying = true;
      }).catch(() => {
        // 可能被浏览器拦截，处理权限请求或提示
        this.isPlaying = false;
      });
    },
    toggleMusic() {
      const music = this.$refs.bgMusic;
      if (this.isPlaying) {
        music.pause();
        this.isPlaying = false;
      } else {
        music.play();
        this.isPlaying = true;
      }
    },
    goFb() {
      const isIOS = /iPhone|iPod|iOS/i.test(navigator.userAgent);
      const platform = isIOS ? 'ios' : 'and';
      const contentId = isIOS ? 'default_ios' : 'default_android';
      // 平台特定事件
      window.fbq('track', `click_${platform}`);
      window.gtag('event', `${platform}点击`);

      // 统一的 purchase 数据
      window.fbq('track', 'Purchase', {
        value: 0.00,
        currency: 'USD',
        content_type: 'product',
        content_ids: [contentId],
        contents: [{ id: contentId, quantity: 1 }]
      });

      // 统一的 andios 埋点
      window.fbq('track', 'click_andios');

      // 自定义统计日志
      this.logger.sum("蜗牛_港澳台五周年_前导页facebook按钮点击次数");

      // 埋点
      window.qcq("track", "click", { "store": "android" });
      window.qcq("track", "click", { "store": "ios" });

      const { utm_source, utm_medium, utm_campaign, utm_content } = analysisParams(window.location.href);
      window.qcq("track", "book", {
        game_id: 120,
        utm_source: utm_source || '',
        utm_medium: utm_medium || '',
        utm_campaign: utm_campaign || '',
        utm_content: utm_content || '',
        os: !navigator.userAgent.match(/(iPhone|iPod|ios)/i) ? 'Android' : 'IOS',
      })


      // 跳转 Facebook
      window.open('https://www.facebook.com/TheMarvelousSnail/posts/pfbid0sQG8VCpx1q1CRANL26jjvpvL4SHmvWoHWmFzMJ4hA8nniA8MSgnsvK8VvZerc16xl', '_blank');
    },
    monitoringEquipment() {
      const { protocol, host, search } = window.location;
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `${protocol}//${host}/snail_5thLeading/enter${getTimeStamp()}${search}`
      }
    }
  }
};
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/snail_5thLeading/pc/index.vue